import React from 'react'

import { RequestFlows } from 'components/inbox/RequestFlows'
import { bodyStyles } from './MemberCommsPoptart.styles'

// Simple wrapper that receives setShouldConfirmClose and maps it to setShouldAlert
export const MemberCommsPoptartContent = ({
  requestTitle,
  closePoptart,
  setShouldConfirmClose, // Automatically passed by sidecar-components Poptart
}) => (
  <div data-testid="info_poptartBody" className={bodyStyles}>
    {!requestTitle && (
      <h4 className="pb-2" data-testid="info_poptartDescription">
        What can we help you with?
      </h4>
    )}
    <RequestFlows
      setOpen={closePoptart}
      setShouldAlert={() => setShouldConfirmClose?.(true)}
    />
  </div>
)
